import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LISTA_VERIFICACAO_IDENTIDADE,
  APROVA_VERIFICACAO_IDENTIDADE,
  REPROVA_VERIFICACAO_IDENTIDADE,
} from 'constants/ActionTypes';
import requisicaoApiCarteirinha from 'util/ApiCarteirinha';
import {
  listaVerificacaoIdentidadeSucesso,
  listaVerificacaoIdentidadeErro,
  aprovaVerificacaoIdentidadeSucesso,
  reprovaVerificacaoIdentidadeSucesso,
  verificacaoIdentidadeErro,
} from 'actions/VerificacaoIdentidade';

/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/

const getVerificacoes = async (pagina, tamanhoPagina, status) =>
  await requisicaoApiCarteirinha
    .get(`/v1/verificacao-identidade?status=${status}&pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`)
    .then(r => r)
    .catch(e => e);

/*#################################################################################################################*/
/* ------------------------------------- Requests do tipo PATCH ----------------------------------------------------*/

const patchAprovar = async (id) =>
  await requisicaoApiCarteirinha
    .patch(`/v1/verificacao-identidade/${id}/aprovar`)
    .then(r => r)
    .catch(e => e);

const patchReprovar = async (id, motivo) =>
  await requisicaoApiCarteirinha
    .patch(`/v1/verificacao-identidade/${id}/reprovar`, { motivo })
    .then(r => r)
    .catch(e => e);

/*#################################################################################################################*/
/* ----------------------------------------------- Sagas ----------------------------------------------------------*/

function* listarSaga({ payload }) {
  try {
    const { pagina, tamanhoPagina, status } = payload;
    const result = yield call(getVerificacoes, pagina, tamanhoPagina, status);
    if (result.response && result.response.status >= 400) {
      yield put(listaVerificacaoIdentidadeErro('Erro ao carregar verificações.'));
    } else {
      yield put(listaVerificacaoIdentidadeSucesso(result.data));
    }
  } catch (error) {
    yield put(listaVerificacaoIdentidadeErro('Erro ao carregar verificações.'));
  }
}

function* aprovarSaga({ payload }) {
  try {
    const result = yield call(patchAprovar, payload.id);
    if (result.response && result.response.status >= 400) {
      yield put(verificacaoIdentidadeErro('Erro ao aprovar verificação.'));
    } else {
      yield put(aprovaVerificacaoIdentidadeSucesso());
    }
  } catch (error) {
    yield put(verificacaoIdentidadeErro('Erro ao aprovar verificação.'));
  }
}

function* reprovarSaga({ payload }) {
  try {
    const result = yield call(patchReprovar, payload.id, payload.motivo);
    if (result.response && result.response.status >= 400) {
      yield put(verificacaoIdentidadeErro('Erro ao reprovar verificação.'));
    } else {
      yield put(reprovaVerificacaoIdentidadeSucesso());
    }
  } catch (error) {
    yield put(verificacaoIdentidadeErro('Erro ao reprovar verificação.'));
  }
}

export function* watchListar() {
  yield takeEvery(LISTA_VERIFICACAO_IDENTIDADE, listarSaga);
}

export function* watchAprovar() {
  yield takeEvery(APROVA_VERIFICACAO_IDENTIDADE, aprovarSaga);
}

export function* watchReprovar() {
  yield takeEvery(REPROVA_VERIFICACAO_IDENTIDADE, reprovarSaga);
}

export default function* rootSaga() {
  yield all([
    fork(watchListar),
    fork(watchAprovar),
    fork(watchReprovar),
  ]);
}
